'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { AjaxForm } from 'modules/ajax-form';
import { tinymce5 } from 'settings';

let settings = {
    fieldSelector: '.js-ajax-form__field',
    fieldNamePrefix: '.js-ajax-form__field--',
    contentSelector: '.js-ajax-form__content',
    submitSelector: '.js-ajax-form__submit',
    errorClass: 'is-error',
    dateOpt: {
        language: 'ru',
        format: 'dd.mm.yyyy',
        autoclose: true,
        minView: 2,
        startDate: '01.01.2018'
    },
    timeOpt: {
        language: 'ru',
        format: 'hh:ii',
        autoclose: true,
        maxView: 2
    },
    dateTimeOpt: {
        language: 'ru',
        format: 'dd.mm.yyyy hh:ii',
        autoclose: true,
        startDate: '01.01.2020 00:00'
    },
    tinymce: tinymce5
};


class Form {
    constructor(el, options, modal) {
        this.el = el;
        this.$modal = modal;
        this.dependsOf = {};
        this.hasDepends = {};
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Form/init ]', this.el);

        this.$form = $(this.el);
        this.$fields = this.opt.$fields || $(this.opt.fieldSelector, this.el);
        this.$content = this.opt.$content || $(this.opt.contentSelector).filter('[data-form_id="' + this.$form.data('form_id') + '"]');

        this._initFields();
        this._initEvents();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}
    }
    submit() {
        console.log('[ Form/submit ]', this.el);

        if (!this.isLoading) {
            this._beforeSubmit();
            this._processSubmit();
            //this._afterSubmit();
        }
    }
    _initFields() {
        let self = this;

        this.$fields.filter(this.opt.fieldNamePrefix + 'captcha').remove();
        //$('input[type=file]').styler();

        this.$fields.filter('.t-file, .t-fileset').each(function() {
            console.log('[ Form/file init ]', $(this));
            let $field = $(this);
            if ($field.hasClass('t-file')) {
                $('input.fileupload', $field).fileupload();
            } else if ($field.hasClass('t-fileset')) {
                function setupFile($el) {
                    $('input.fileupload', $el).fileupload({
                        afterUpload: function(data) {
                            var $div = $(document.createElement('div')).addClass('inputfile').appendTo($el.parent());
                            var $input = $(this).clone(true).off().attr('name', $field.data('name')).data({ file_id: null, file_src: null, publ_name: null }).appendTo($div);
                            setupFile($div);
                        },
                        afterDelete: function(data) {
                            if ($el.parent().find('.inputfile').length > 1) {
                                $(this).unfileupload();
                                $el.remove();
                            }
                        }
                    });
                }
                $field.find('.inputfile').each(function(i) {
                    setupFile($(this));
                });
            }
        });

        let $dependsOf = this.$form.find(".depends-of");
        for (let i = 0; i < $dependsOf.length; i ++) {
            let dependsOfArr = $dependsOf.eq(i).data('dependsOf').split(/\,/);
            let dependsOfHash = {};
            for (let j = 0; j < dependsOfArr.length; j ++) {
                dependsOfHash[ dependsOfArr[j] ] = true;
            }
            this.dependsOf[ $dependsOf.eq(i).data('name') ] = dependsOfHash;
        }
        let $hasDepends = this.$form.find(".has-depends");
        for (let i = 0; i < $hasDepends.length; i ++) {
            let hasDependsArr = $hasDepends.eq(i).data('hasDepends').split(/\,/);
            let hasDependsHash = {};
            for (let j = 0; j < hasDependsArr.length; j ++) {
                hasDependsHash[ hasDependsArr[j] ] = true;
            }
            this.hasDepends[ $hasDepends.eq(i).data('name') ] = hasDependsHash;
        }

        tinymce.init(self.opt.tinymce);

        this.$form.find('textarea.tinymce').each(function() {
            if (!window.__TINYMCE_COUNTER) { window.__TINYMCE_COUNTER = 1 }
            this.id = 'tinymce-' + window.__TINYMCE_COUNTER;
            window.__TINYMCE_COUNTER ++;
            let editor = new tinymce.Editor(this.id, self.opt.tinymce, tinymce.EditorManager);
            editor.render();

            if (this.required) {
                this.required = false;
            }
        });

        $(document).on('focusin', function(e) {
            if ($(e.target).closest('.tox-tinymce-aux, .moxman-window, .tam-assetmanager-root').length) {
                e.stopImmediatePropagation();
            }
        });

    }
    _initEvents() {
        let self = this;

        this.$form.on('change', '.has-depends select, .has-depends input, .has-depends textarea', (e) => {

            var data = this.$form.serializeArray();
            var params = [];
            for (let i = 0; i < data.length; i ++) {
                if (!this.hasDepends[ this.name ] || !this.hasDepends[ this.name ][ data[i].name ]) {
                    params.push(data[i]);
                }
            }
            if (this.$form.attr('name') != '') {
                params.push({ name: '_form_name', value: this.$form.attr('name') })
            }

            params.push({ name: '_changed', value: e.target.name });

            Ajax.get('get_form_fields', params).then((data) => {
                if (data.fields) {
                    for (var i = 0; i < data.fields.length; i ++) {
                        var $field = this.$form.find('.n-'+data.fields[i].name+' .field-value');
                        var val = $field.find("[name='"+data.fields[i].name+"']").xval();
                        $field.html(data.fields[i].html);
                        if (!$field.find("[name='"+data.fields[i].name+"']").data('change')) {
                            if (val instanceof Array) {
                                if (val.length !== 0) {
                                    //$field.find("[name='"+data.fields[i].name+"']").xval(val);
                                }
                            } else {
                                if (val !== '') {
                                    //$field.find("[name='"+data.fields[i].name+"']").xval(val);
                                }
                            }
                        }
                        //setupField($field.parent());
                    }
                }
            }).catch(function(error) {
                console.error('[ Form/_processSubmit ] Sending failed', error);

                this._afterSubmit(data);
            });
        });

        this.$form.on('submit', (e) => {
            if (!this.opt.skip_submit) {
                e.preventDefault();
                console.log(e);
                this.submit();
            }
        });
        this.$form.find(this.opt.submitSelector).on('click', function(e) {
            e.preventDefault();
            console.log(this);
            let name = $(this).attr('name');
            let value = $(this).attr('value');
            console.log(name, value);
            self.$form.find('[name="' + name + '"]').attr('value', value);
            self.submit();
        });
    }
    _beforeSubmit() {
        this.isLoading = true;

        this.$fields.removeClass(this.opt.errorClass);
        tinymce.triggerSave();
        //$.fancybox.showLoading();
    }
    _processSubmit() {
        this.$fields.find('[disabled=disabled]').prop('disabled', false);
        let params = new FormData(this.el[0]);

        Ajax.get('handler', params).then((data) => {
            if (data.ok) {
                console.log('[ Form/_processSubmit ] Sent successfully');

                if (this.$form.data('goal')) {
                    $(window).trigger('ajaxForm:form:goal', this.$form.data());
                }

                if (this.$content.length) {
                    this.$content.html(data.content);
                    this.$form.remove();
                } else {
                    this.$form.replaceWith(data.content);
                }
                this._afterSubmit(data);
            } else if (data.errors) {
                console.log('[ Form/_processSubmit ] Got errors', data.errors);

                if (data.error_text) {
                    $(".form-error", this.$form).html(data.error_text).show();
                }
                for (let p in data.errors) {
                    console.log(this.opt.errorClass);
                    this.$fields.filter(this.opt.fieldNamePrefix + p).addClass(this.opt.errorClass);
                }
                this._afterSubmit(data);
            }
        }).catch(function(error) {
            console.error('[ Form/_processSubmit ] Sending failed', error);

            this._afterSubmit(data);
        });
    }
    _afterSubmit(data) {
        //$.fancybox.hideLoading();

        //if ($.fancybox.isOpen) {
        //    $.fancybox.update();
        //}

        this.isLoading = false;
        if (data.content) return;
        if (data.ok) {
            this.$modal.on('hidden.bs.modal', function() {
                //console.log(this.$modal);
                //this.$modal.remove();
                delete this.$modal;
                if (data.modal) {
                    var obj = data.modal;
                    //if (this.$modal) {
                    //    this.$modal.modal('show');
                    //} else if (!self.loading) {
                        self.loading = true;
                        self.ajaxForm = new AjaxForm({skip_init: 1});
                        self.ajaxForm.getForm(self, $.extend({}, { iface: data.modal.replace(/\-/g, '_') }, data));
                    //}
                } else {
                    if (data.back) {
                        document.location.href = document.location.protocol + '//' + document.location.hostname + data.back;
                        if (data.reload) {
                            document.location.reload();
                        }
                    } else {
                        if (!data.noreload) {
                            document.location.reload();
                        }
                        if (data.export) {
                          saveAs(document.location.protocol + '//' + document.location.hostname + data.file_path, data.file_name);
                        }
                    }
                }
            }).modal('hide');
        }
    }
}


export {
    Form
};
